<template>
  <div id="cont">
    <div id="nav">
      <Navbar @updateShow="updateShow" />
    </div>
    <Popup :selected="selectedTool" v-if="checkTool()" />
    <div id="main" :class="{ mainopen: show }">
      <router-view />
    </div>
  </div>
</template>
<script>
  import Navbar from '@/components/Navbar.vue'
  import Popup from '@/components/Popup.vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'App',
    components: {
      Navbar,
      Popup,
    },
    data() {
      return {
        show: false,
      }
    },
    computed: {
      ...mapState(['logged', 'selectedTool']),
    },
    methods: {
      ...mapActions([
        'logout',
        'getToken',
        'getTranslations',
        'getExtraFields',
        'getEquipments',
      ]),
      checkTool() {
        let result = false
        if (this.selectedTool != null) {
          result = true
          document.body.style.overflow = 'hidden'
        } else if (this.selectedTool == null) {
          document.body.style.overflow = 'auto'
        }
        return result
      },
      updateShow(value) {
        this.show = value
      },
    },
    async created() {
      await this.getToken()
      await this.getExtraFields()
      await this.getTranslations()
      await this.getEquipments()
    },
  }
</script>
<style>
  #main {
    transition: margin-left 0.3s;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
  }

  .mainopen {
    transition: margin-left 0.3s;
    /* overflow: hidden; */
    margin-left: 250px;
  }

  html,
  body,
  #app,
  #cont {
    height: 100%;
    overflow-x: hidden;
  }
  a {
    text-decoration: none;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .form-control {
    border-radius: initial !important;
  }
  #nav {
    padding: 30px;
  }

  /* #nav a.router-link-exact-active {
    color: #42b983;
  } */

  .viewcontent {
    display: block;
    max-width: 1140px;
    width: 100%;
    margin: 10px auto 120px auto;
    text-align: center;
  }
  /* GLOBAL COLORS */
  .main_color {
    color: #a7a7a7;
  }
  .a_color {
    color: #201c1d;
  }
  .contrast_color {
    color: #fff;
  }
  .primary_color {
    color: #d25252;
  }
  .tertiary_color {
    color: #54595f;
  }
  .fourth_color {
    color: #303030;
  }
  .fifth_color {
    color: #7a7a7a;
  }
  .sixth_color {
    color: #a7a7a7;
  }
  .retail_color {
    color: #ff4a33;
  }
  .black_color {
    color: #000;
  }
  .warning_color {
    color: #ffc107;
  }

  /* ------------- */
  .contrast_bg_color {
    background-color: #fff;
  }
  .primary_bg_color {
    background-color: #d25252;
  }
  .secundary_bg_color {
    background-color: #b3adad;
  }
  .tertiary_bg_color {
    background-color: #54595f;
  }
  .fourth_bg_color {
    background-color: #303030;
  }
  .fifth_bg_color {
    background-color: #7a7a7a;
  }
  .sixth_bg_color {
    background-color: #a7a7a7;
  }
  .seventh_bg_color {
    background-color: #fdfdfd;
  }
  .eighth_bg_color {
    background-color: #e8e8e8;
  }
  .calendar_bg_today {
    background-color: #d252524b;
  }
  .calendar_bg_available {
    background-color: #94ffb887;
  }
  .calendar_bg_notavailable {
    background-color: #bb4040;
  }
  .nineth_bg_color {
    background-color: #e9e9e9;
  }
  .retail_bg_color {
    background-color: #ededed;
  }
  .tenth_bg_color {
    background-color: #e6e5e5;
  }

  /* ------------- */
  .primary_bg_color_transparent {
    background-color: #d2525294;
  }
  .contrast_bg_color_transparent {
    background-color: #ffffffb0;
  }
  .fourth_bg_color_transparent {
    background-color: #30303080;
  }
  .sixth_bg_color_transparent {
    background-color: #a7a7a7a1;
  }
  .seventh_bg_color_transparent {
    background-color: #fdfdfd9e;
  }
  .black_bg_transparent {
    background-color: #000000b3;
  }

  /* ------------- */
  .border_shadow {
    border-color: #d4d4d4;
  }

  .border_category {
    border-color: #54595f;
  }
  .border_primary {
    border-color: #d25252;
  }
  .border_fourth {
    border-color: #303030;
  }
  .border_sixth {
    border-color: #7a7a7a;
  }
  .border_tenth {
    border-color: #e6e5e5;
  }
  .border_calendar {
    border-color: #f5f3f3;
  }

  /* ------------- */
  .product:hover .productitem {
    color: #d25252;
  }
  .product:hover .productitem .svgicon {
    /* primary_color https://codepen.io/sosuke/pen/Pjoqqp*/
    filter: invert(62%) sepia(24%) saturate(950%) hue-rotate(100deg)
      brightness(96%) contrast(87%);
  }

  .slider .position.is-active,
  .slider .position.is-active:hover {
    background-color: #d25252;
  }

  .slider .position:hover {
    background-color: #7a7a7a;
  }
  .messagecont .right:before {
    border-color: #d25252;
  }
  .messagecont .left:before {
    border-color: #a7a7a7;
  }

  /* ------------- */
  .info_color {
    border: 1px solid #03a9f4;
    color: #03a9f4;
    background-color: #03a8f43a;
  }
  .error_color {
    border: 1px solid #d25252;
    color: #d25252;
    background-color: #d2525233;
  }
  /* #nav a.router-link-exact-active {
    background-color: #8b8b8b;
    color: #fff;
  } */
  .slider .arrow svg {
    fill: #d25252;
    font-size: 10px;
  }
  .businessinfo ::placeholder {
    color: #fff;
  }
  .toolform .valid input {
    border-bottom-color: #03a9f4;
  }
  .toolform .invalid input {
    border-bottom-color: #ffc107;
  }
  .multiselect-tag i:before {
    color: #fff;
  }
  .multiselect-tag {
    background: #a7a7a7;
  }
  .multiselect-input {
    border-color: #54595f;
  }
  .multiselect-option.is-pointed {
    background: #fdfdfd;
  }
  .multiselect-multiple-label,
  .multiselect-placeholder,
  .multiselect-single-label {
    color: #54595f;
  }
  .multiselect-option:active {
    background-color: #a7a7a7;
  }
  .multiselect-caret {
    border-color: #54595f;
  }
  .is-disabled .multiselect-input {
    background-color: #fff;
  }
  .svgicon {
    /* .fifth_color https://codepen.io/sosuke/pen/Pjoqqp */
    filter: invert(53%) sepia(1%) saturate(427%) hue-rotate(18deg)
      brightness(89%) contrast(85%);
  }
</style>
